import React, {useMemo} from 'react';
import {Box, Button} from '@mui/material';

import {LatestAtr_advisers, LatestAtr_getCurrentUser} from '../../schema-types/LatestAtr';
import {amendReasonField, AtrFormValues} from './AtrFields';

import {UPDATES} from '../../shared/UPDATES';
import {ActionType, AutoField as AutoFieldNew, FormField} from '../AutoForm/AutoFieldNew';
import {useAutoForm} from '../AutoForm/useAutoForm';
import ScoreSlider from './ScoreSlider';

const SelectAdviser: React.FC<{
  advisers: LatestAtr_advisers[] | LatestAtr_getCurrentUser;
}> = ({advisers}) => {
  const staff = Array.isArray(advisers) ? advisers : [advisers];
  const {values, errors, setFieldValue} = useAutoForm<AtrFormValues>();

  const adviserField: FormField = useMemo(() => {
    const options = staff.map((contactAdviser) => {
      const label = `${contactAdviser.firstName} ${contactAdviser.lastName}`;
      return {
        label,
        value: contactAdviser.id,
      };
    });

    const helpText = errors?.adviserId || 'There are no advisers to assign';

    return {
      type: ActionType.select,
      id: 'adviserId',
      label: 'Requester',
      options,
      helper: helpText,
    };
  }, [advisers]);

  return <AutoFieldNew field={adviserField} />;
};

const AtrInputs: React.FC<{
  loadingAtr: boolean;
  advisers: LatestAtr_advisers[] | LatestAtr_getCurrentUser;
  showManualAmend: boolean;

  // getSubmitHandler: getAtrSubmitHandler;
}> = ({loadingAtr, advisers, showManualAmend}) => {
  const {isSubmitting, values, setFieldValue, setSubmitting, errors} =
    useAutoForm<AtrFormValues>();

  const manualEntryDisabled = isSubmitting || loadingAtr;

  return (
    <>
      <SelectAdviser advisers={advisers} />
      <Box width="100%" visibility={values.action === 'manual' ? 'visible' : 'hidden'}>
        <ScoreSlider />
      </Box>
      {values.action === 'manual' && (
        <Box mt={2} mb={2} display="flex" justifyContent="space-between" width="100%">
          <AutoFieldNew data-testid="score-slider-reason" field={amendReasonField} />
        </Box>
      )}
      <Box display="flex" justifyContent="space-between" width="100%">
        <Button
          variant="contained"
          size="medium"
          color="primary"
          disabled={manualEntryDisabled || isSubmitting}
          type="submit"
        >
          {values.action === 'manual' ? 'Set Manual Score' : 'Send Questionnaire'}
        </Button>
        <Box ml={2} />
        <Button
          variant="contained"
          size="medium"
          color="primary"
          component="a"
          href="https://risk.saltus.co.uk/"
          target="_blank"
          rel="noreferrer"
        >
          Calculate Paper-Based RTQ Score
        </Button>
        <Box flex={1} />
        {showManualAmend && values.action !== 'manual' && (
          <Button
            color="primary"
            value="check"
            size="medium"
            // selected={values.action === 'manual'}
            onClick={() => {
              setFieldValue(
                UPDATES._1700,
                'action',
                values.action === 'request' ? 'manual' : 'request'
              );
              if (values.amendedValue == null) {
                setFieldValue(UPDATES._1701, 'amendedValue', 1);
              }
            }}
            disabled={manualEntryDisabled}
          >
            Manual Entry
          </Button>
        )}
      </Box>
    </>
  );
};

export default AtrInputs;
